// extracted by mini-css-extract-plugin
export default {"container":"Preferred_container__xZwRN"};